import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ADMIN_RECINTO, ADMIN } from '../../helpers/Constants';
import { useSelector } from 'react-redux';

const AdminRecintoGuard = ({ children }) => {
  const { isAuthenticated, user } = useSelector(state => state.auth);

  if (isAuthenticated) {
    if (user?.tipo !== ADMIN_RECINTO && user?.tipo !== ADMIN)
      return <Redirect to="/" />;
  } else {
    return <Redirect to="/" />;
  }

  return <>{children}</>;
};

AdminRecintoGuard.propTypes = {
  children: PropTypes.node
};

export default AdminRecintoGuard;
